import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "6",
  height: "10",
  fill: "none",
  viewBox: "0 0 6 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.538 9.346.75 8.54l3.615-3.518L.75 1.505l.788-.806 4.027 3.918v.807z"
    }, null, -1)
  ])))
}
export default { render: render }